// extracted by mini-css-extract-plugin
export default {"centeredContent":"user-create-form_centeredContent__PZBJY","inputLabel":"user-create-form_inputLabel__DF2kF","cniPreview":"user-create-form_cniPreview__JJcqE"};